module.exports = __webpack_public_path__ + "static/media/pg-liberacao.954fdc6f.png";